<template>
  <img
    v-if="full"
    src="@/assets/img/grapeperks/logo/imagotipo-uc.svg" alt="GrapePerks"
    :style="{width, height}">
  <img
    v-else
    src="@/assets/img/grapeperks/logo/isotipo.svg" alt="GrapePerks"
    :style="{width, height}">
</template>

<script>
export default {
  props: {
    full: {
      type: Boolean,
      required: false,
      default: true,
    },
    width: {
      type: String,
      required: false,
      default: 'auto',
    },
    height: {
      type: String,
      required: false,
      default: 'auto',
    },
  },
};
</script>
